import * as types from 'store/actions/types';
import produce from 'immer';

const INITIAL_STATE = {
	loading: true,
	error: false,
	data: []
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ****************** CLEAR DATA ******************
			case types.CLEAR_PANEL_STATE:
				return { ...INITIAL_STATE };

			// *************** FETCH PROVIDERS ***************
			case types.FETCH_PROVIDERS_LOADING:
				draft.loading = true;
				draft.error = false;
				break;

			case types.FETCH_PROVIDERS_SUCCESS:
				draft.loading = false;
				draft.data = action.payload.data;
				break;

			case types.FETCH_PROVIDERS_ERROR:
				draft.error = action.payload;
				break;

			default:
				return state;
		}
	});
